/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const TableVerified: React.FC<Props> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.33496 19H2C1.44772 19 1 18.5523 1 18V10.8359H9.33496V19ZM19 18C19 18.5523 18.5523 19 18 19H10.835V10.8359H19V18ZM9.33496 9.33594H1V2C1 1.44772 1.44772 1 2 1H9.33496V9.33594ZM18 1C18.5523 1 19 1.44772 19 2V9.33594H10.835V1H18Z"
      fill={color ?? props?.style?.color}
    />
  </svg>
);

export default TableVerified;
